// extracted by mini-css-extract-plugin
export default {"PrivateEventIndicator":"_PrivateEventIndicator--U7q1i"};